import { CardContainer } from '../containers/card'

export default function Work(){
return <CardContainer />
}